import { LogIn, LogOut } from "lucide-react";
import { useVisitorAuth } from "@/context/VisitorAuthContext";

export function GoogleSignInButton({ label = "Sign in with Google" }) {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + window.location.pathname;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <button
      type="button"
      data-testid="google-signin-button"
      onClick={handleLogin}
      className="flex w-full items-center justify-center gap-3 rounded-sm border border-navy/25 bg-white px-6 py-3.5 text-sm font-bold text-navy transition-colors duration-200 hover:border-navy hover:bg-navy hover:text-white"
    >
      <svg className="h-5 w-5" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" />
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
      </svg>
      {label}
    </button>
  );
}

export function SignInGate({ title, text }) {
  return (
    <div data-testid="signin-gate" className="text-center">
      <p className="font-display text-xl font-bold text-navy">{title}</p>
      <p className="mx-auto mt-2 max-w-sm text-sm leading-relaxed text-muted-foreground">{text}</p>
      <div className="mx-auto mt-5 max-w-sm">
        <GoogleSignInButton label="Sign in with Google to Continue" />
      </div>
      <p className="mt-3 text-[11px] text-muted-foreground">
        One-tap Google sign-in &mdash; no passwords, your details stay secure.
      </p>
    </div>
  );
}

export function SignedInChip() {
  const { visitor, signOut } = useVisitorAuth();
  if (!visitor) return null;
  return (
    <div
      data-testid="signed-in-chip"
      className="mb-4 flex items-center justify-between gap-3 rounded-sm border border-green-200 bg-green-50 px-4 py-2.5"
    >
      <p className="flex items-center gap-2 text-xs font-semibold text-green-800">
        <LogIn className="h-3.5 w-3.5" aria-hidden="true" />
        Signed in as {visitor.email}
      </p>
      <button
        type="button"
        data-testid="visitor-signout-button"
        onClick={signOut}
        className="flex items-center gap-1 text-[11px] font-bold uppercase tracking-wider text-green-700 hover:text-red-600"
      >
        <LogOut className="h-3 w-3" aria-hidden="true" />
        Sign Out
      </button>
    </div>
  );
}
